export enum GrlProperty {
    RuralArea = "RURAL_AREA",
    SparselyPopulatedArea = "SPARSELY_POPULATED_AREA",
    SuburbanArea = "SUBURBAN_AREA",
    UrbanArea = "URBAN_AREA",
    DenselyPopulatedUrbanArea = "DENSELY_POPULATED_URBAN_AREA",
    PeopleGathering = "PEOPLE_GATHERING",
}
